import { render, staticRenderFns } from "./Colaboradores.vue?vue&type=template&id=b0c55ff6&scoped=true"
import script from "./Colaboradores.vue?vue&type=script&lang=js"
export * from "./Colaboradores.vue?vue&type=script&lang=js"
import style0 from "./Colaboradores.vue?vue&type=style&index=0&id=b0c55ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c55ff6",
  null
  
)

export default component.exports